<script>
export default {
    name: "IconFilter"
}
</script>

<template>
    <svg viewBox="0 0 24 24"
         fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              d="M5 6.75h7m-7 10.5h7M5 12h1.75m10.5-5.25H19m-1.75 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 10.5H19m-1.75 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM12 12h7m-7 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
